import { render, staticRenderFns } from "./marketValume.vue?vue&type=template&id=ca95bdd2&scoped=true&"
import script from "./marketValume.vue?vue&type=script&lang=js&"
export * from "./marketValume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca95bdd2",
  null
  
)

export default component.exports